import React, { useContext, useCallback } from "react";
import { SelectAsync } from "../selectAsync";
import Creatable from "react-select/creatable";
import { Row, Col, Form } from "react-bootstrap";
import { RequiredMarkContext } from "components/contexts/requiredMarkContext";
import RequiredMark from "components/requiredMark";
import Skeleton from "components/skeleton";
import styles from "../../fields/inputs/fields.module.scss";

import fp from "lodash/fp";

const SelectAsyncForBankName = ({
	input,
	meta,
	findOption,
	onChangeCb,
	blurLoading,
	disabled,
	hideRequiredMark, //works only with RequiredMarkContext
	readOnly,
	...props
}) => {
	const showRequiredMark =
		useContext(RequiredMarkContext) && !hideRequiredMark && !disabled;

	const checkSpanRequired = showRequiredMark && <RequiredMark />;

	const formatCreateLabel = value => `Enter "${value}"`;

	const filterOption = (option, query) => {
		if (option.data.__isNew__) return true;

		return (
			option.data.value &&
			option.data.value.toLowerCase().includes(query.toLowerCase())
		);
	};

	const SelectWithError = (
		<>
			<SelectAsync
				{...props}
				SelectComponent={Creatable}
				value={findOption(input.value)}
				onChangeCb={onChangeCb}
				formatCreateLabel={formatCreateLabel}
				filterOption={filterOption}
				debounceTimeout={300}
				cacheOptions
				additional={{ page: 0 }}
				input={input}
				meta={meta}
			/>
		</>
	);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const SelectdWithLoader = useCallback(
		fp.cond([
			[() => blurLoading, () => <Skeleton />],
			[
				() => readOnly,
				({ input }) => (
					<div className={styles.readOnlyInput}>{input.value}</div>
				),
			],
			[fp.T, ({ component }) => component],
		]),
		[blurLoading],
	);

	return (
		<Row style={{ marginBottom: 22 }}>
			<Form.Label column sm={6}>
				Bank Name{checkSpanRequired}
			</Form.Label>
			<Col sm={6}>
				<SelectdWithLoader input={input} component={SelectWithError} />
			</Col>
		</Row>
	);
};

export default SelectAsyncForBankName;
